import { z } from "zod";

import { DynamicZoneSchema } from "@shared/content-types/schemas/dynamicZone.schema";
import { StrapiMediaSchema } from "@shared/content-types/schemas/media.schema";
import { SeoSchema } from "@shared/content-types/schemas/seo.schema";
import { AuthorSchema } from "@shared/ui/author";

export const ArticleHeroShema = z.object({
  id: z.number().int().positive(),
  title: z.string().min(1),
  timeToRead: z.string().min(1),
  author: AuthorSchema,
  mainImage: StrapiMediaSchema,
  description: z.string().optional(),
});

export const ArticleShema = z.object({
  id: z.number().int().positive(),
  slug: z.string().min(1),
  documentId: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime(),
  title: z.string().min(1),
  hero: ArticleHeroShema,
  content: DynamicZoneSchema.optional(),
  moreArticles: z.any(),
  seo: SeoSchema.optional().nullable(),
});

export const ArticlePageShema = ArticleShema.extend({
  moreArticles: z.array(ArticleShema),
});

export const ArticlePageDtoShema = z.object({
  data: z.any(),
});
